import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterTaskStatusSelect ({ value, onChange = () => null, att }) {
  const { t } = useTranslate()

  const { taskStatus } = useStoreState((state) => state.filter)

  const { getTaskStatusThunk } = useStoreActions((actions) => actions.filter)

  const options = _.map(taskStatus, (item) => {
    return {
      label: item?.value_list_name,
      value: item?.value_list_id,
    }
  })

  useAsync(async () => {
    getTaskStatusThunk()
  }, [])

  return (
    <Styled className='filter-report-type-select-component'>
      <Select
        defaultValue={value}
        dropdownMatchSelectWidth={false}
        options={options}
        placeholder={t('Please select task status')}
        onChange={onChange}
        {...att}
      />
    </Styled>
  )
}
